import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IChartTemplateMatch, defaultValue } from '../../model/chart-template-match.model';

export const ACTION_TYPES = {
  FETCH_CHARTTEMPLATEMATCH_LIST: 'chartTemplateMatch/FETCH_CHARTTEMPLATEMATCH_LIST',
  FETCH_CHARTTEMPLATEMATCH: 'chartTemplateMatch/FETCH_CHARTTEMPLATEMATCH',
  CREATE_CHARTTEMPLATEMATCH: 'chartTemplateMatch/CREATE_CHARTTEMPLATEMATCH',
  UPDATE_CHARTTEMPLATEMATCH: 'chartTemplateMatch/UPDATE_CHARTTEMPLATEMATCH',
  DELETE_CHARTTEMPLATEMATCH: 'chartTemplateMatch/DELETE_CHARTTEMPLATEMATCH',
  RESET: 'chartTemplateMatch/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IChartTemplateMatch>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type ChartTemplateMatchState = Readonly<typeof initialState>;

// Reducer

export default (state: ChartTemplateMatchState = initialState, action): ChartTemplateMatchState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATEMATCH_LIST):
    case REQUEST(ACTION_TYPES.FETCH_CHARTTEMPLATEMATCH):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_CHARTTEMPLATEMATCH):
    case REQUEST(ACTION_TYPES.UPDATE_CHARTTEMPLATEMATCH):
    case REQUEST(ACTION_TYPES.DELETE_CHARTTEMPLATEMATCH):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATEMATCH_LIST):
    case FAILURE(ACTION_TYPES.FETCH_CHARTTEMPLATEMATCH):
    case FAILURE(ACTION_TYPES.CREATE_CHARTTEMPLATEMATCH):
    case FAILURE(ACTION_TYPES.UPDATE_CHARTTEMPLATEMATCH):
    case FAILURE(ACTION_TYPES.DELETE_CHARTTEMPLATEMATCH):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATEMATCH_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_CHARTTEMPLATEMATCH):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_CHARTTEMPLATEMATCH):
    case SUCCESS(ACTION_TYPES.UPDATE_CHARTTEMPLATEMATCH):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_CHARTTEMPLATEMATCH):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/chart-template-matches';

// Actions

export const getEntities: ICrudGetAllAction<IChartTemplateMatch> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATEMATCH_LIST,
    payload: axios.get<IChartTemplateMatch>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IChartTemplateMatch> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_CHARTTEMPLATEMATCH,
    payload: axios.get<IChartTemplateMatch>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IChartTemplateMatch> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_CHARTTEMPLATEMATCH,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IChartTemplateMatch> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_CHARTTEMPLATEMATCH,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IChartTemplateMatch> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_CHARTTEMPLATEMATCH,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
